module.exports = __webpack_public_path__ + "f.no2.c564d464.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/f.no2.jpg
// module id = J8QA
// module chunks = 0